






















import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import TestingBegin from './Begin.vue'
import TestingStepper from './Stepper.vue'

import {mapGetters} from "vuex";

@Component({
  name: "Testing",
  components: { TestingBegin, TestingStepper },
  computed: {
    ...mapGetters({
      step: "testing/step"
    })
  }
})
export default class Testing extends Vue{
  private nextStepAvailable = false;
}
